import { render } from "./TableListBodyEmpty.vue?vue&type=template&id=49b00403&scoped=true"
import script from "./TableListBodyEmpty.vue?vue&type=script&lang=js"
export * from "./TableListBodyEmpty.vue?vue&type=script&lang=js"

import "./TableListBodyEmpty.vue?vue&type=style&index=0&id=49b00403&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b00403"]])

export default __exports__